// Routes of the documents item + the URL contracts other items link to.

import type { Me } from '@/lib/me';

export const STATEMENTS_PATH = '/accounts/statements';
export const RECEIVABLES_PATH = '/accounts/receivables';
export const INVOICES_PATH = '/accounts/invoices';

/** Side-panel states of the statement (URL state, so a reload keeps them). */
export type StatementPanel = 'receipt' | 'invoice' | 'receipt-view' | 'conflict' | 'local';

export function statementHref(customerId: string, opts: { panel?: StatementPanel; doc?: string; period?: string } = {}): string {
  const q = new URLSearchParams();
  if (opts.period) q.set('period', opts.period);
  if (opts.panel) q.set('panel', opts.panel);
  if (opts.doc) q.set('doc', opts.doc);
  const s = q.toString();
  return `${STATEMENTS_PATH}/${encodeURIComponent(customerId)}${s ? `?${s}` : ''}`;
}

/** The «فاتورة الزيارة» panel for an appointment (host route when Today does not mount the panel itself). */
export function invoiceFromVisitHref(appointmentId: string): string {
  return `${INVOICES_PATH}?appointment=${encodeURIComponent(appointmentId)}`;
}

/** A posted invoice, read-only (installments links `?invoice_id=`, inventory links `/:id`). */
export function invoiceViewHref(invoiceId: string): string {
  return `${INVOICES_PATH}/${encodeURIComponent(invoiceId)}`;
}

/** Capability check matching erp-core auth.Principal.Can (manager and owner hold every switch). Accepts both /me shapes. */
export function hasCap(me: Pick<Me, 'role' | 'capabilities'> | null | undefined, key: string): boolean {
  if (!me) return false;
  if (me.role === 'owner' || me.role === 'manager') return true;
  const caps: unknown = me.capabilities;
  if (Array.isArray(caps)) return caps.includes(key);
  if (caps && typeof caps === 'object') return (caps as Record<string, unknown>)[key] === true;
  return false;
}

export const CAP_CASHIER = 'accounts.cashier';
export const CAP_EXPORT = 'accounts.export';
